module.exports = __webpack_public_path__ + "img/pluto.433fb8de.png";